
export const Login = ()=>{

    return{
        type:"login"
    }
}

export const Logout = ()=>{
    return {
        type:"logout"
    }
}